import { __assign, __awaiter, __decorate, __generator, __metadata } from "tslib";
import { IconError, IconGreenCheck } from '@anex/common';
import { action, observable } from 'mobx';
import { DateTime } from 'luxon';
import * as React from 'react';
export var paymentMethods;
(function (paymentMethods) {
    paymentMethods["creditCard"] = "creditCard";
    paymentMethods["existingCreditCard"] = "existingCreditCard";
    paymentMethods["officeworks30DayAccountHolder"] = "officeworks30DayAccountHolder";
    paymentMethods["directDebit"] = "directDebit";
})(paymentMethods || (paymentMethods = {}));
var SaleStore = (function () {
    function SaleStore(rootStore) {
        var _this = this;
        this.rootStore = rootStore;
        this.accountCode = '';
        this.serviceCode = '';
        this.firstName = '';
        this.paymentReference = '';
        this.loading = false;
        this.ow30DayAccountValid = false;
        this.paymentDetails = null;
        this.paymentMethod = paymentMethods.creditCard;
        this.voucherCode = '';
        this.voucher = null;
        this.promoCode = '';
        this.promo = null;
        this.recaptchaResponse = '';
        this.reset = function () {
            _this.rootStore.planStore.planDetails = _this.rootStore.planStore.getInitialStoreState();
            _this.rootStore.hardwareStore.hardwareDetails = _this.rootStore.hardwareStore.getInitialStoreState();
            _this.rootStore.detailsStore.details = _this.rootStore.detailsStore.getInitialStoreState();
            _this.paymentDetails = _this.getInitialStoreState();
        };
        this.failedSale = function (exception) {
            var sharedProps = {
                dismissible: true,
                title: React.createElement(IconError),
                type: 'danger',
            };
            if (exception.response &&
                exception.response.data &&
                exception.response.data.errors) {
                exception.response.data.errors.map(function (_) {
                    if (_.message === 'Duplicate service already exists.') {
                        _this.rootStore.appStore.gotoState(3);
                    }
                    var alert = __assign(__assign({}, sharedProps), { message: "Payment failed. Please check your details and try again. " + _.message });
                    _this.rootStore.appStore.addAlert(alert);
                });
            }
            else {
                var alert_1 = __assign(__assign({}, sharedProps), { message: 'Payment failed. Please check your details and try again.' });
                _this.rootStore.appStore.addAlert(alert_1);
            }
            _this.loading = false;
        };
        this.getInitialStoreState = function () { return ({
            formInitialValues: _this.getInitialFormValues(),
            formValues: null,
        }); };
        this.getInitialFormValues = function () { return ({
            cardHolderName: '',
            cardNumber: '',
            ccCvc: '',
            ccExpirationDate: '',
        }); };
        this.paymentDetails = this.getInitialStoreState();
    }
    SaleStore.prototype.setRecaptchaResponse = function (response) {
        this.recaptchaResponse = response;
    };
    SaleStore.prototype.setVoucherCode = function (voucherCode) {
        this.voucherCode = voucherCode;
    };
    SaleStore.prototype.setVoucher = function (voucher) {
        this.voucher = voucher;
    };
    SaleStore.prototype.setPromoCode = function (promoCode) {
        this.promoCode = promoCode;
    };
    SaleStore.prototype.setPromo = function (promo) {
        this.promo = promo;
    };
    SaleStore.prototype.setDetailsFromForm = function (details) {
        this.paymentDetails.formValues = details;
    };
    SaleStore.prototype.isLoading = function (loading) {
        this.loading = loading;
    };
    SaleStore.prototype.setPaymentMethod = function (method) {
        this.paymentMethod = method;
    };
    SaleStore.prototype.tokenizeOfficeWorksLogin = function (popup) {
        return __awaiter(this, void 0, void 0, function () {
            var isOssUser, accountRequest, alert_2, error_1, alert_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        isOssUser = false;
                        if (!!this.accountCode) return [3, 2];
                        accountRequest = this.mapAccountCreationRequest();
                        return [4, this.createAccount(accountRequest)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 4, , 5]);
                        return [4, this.rootStore.ccTokenizerClient.TokenizeOw30DayAccount(this.rootStore.config.wholesaleCustomerCode + "-" + this.accountCode, popup, isOssUser)];
                    case 3:
                        _a.sent();
                        this.ow30DayAccountValid = true;
                        alert_2 = {
                            dismissible: false,
                            message: 'You are now signed in.',
                            title: React.createElement(IconGreenCheck),
                            type: 'success',
                        };
                        this.rootStore.appStore.addAlert(alert_2);
                        return [3, 5];
                    case 4:
                        error_1 = _a.sent();
                        alert_3 = {
                            dismissible: true,
                            message: 'You are not a 30 day business account holder.',
                            title: React.createElement(IconError),
                            type: 'danger',
                        };
                        this.rootStore.appStore.addAlert(alert_3);
                        return [3, 5];
                    case 5: return [2];
                }
            });
        });
    };
    SaleStore.prototype.submitCreditCardForm = function (values) {
        return __awaiter(this, void 0, void 0, function () {
            var isOssUser, cardNumber, cardHolderName, ccExpirationDate, accountRequest, creditCard, gateWays, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        isOssUser = false;
                        cardNumber = values.cardNumber, cardHolderName = values.cardHolderName, ccExpirationDate = values.ccExpirationDate;
                        this.loading = true;
                        if (!!this.accountCode) return [3, 2];
                        accountRequest = this.mapAccountCreationRequest();
                        return [4, this.createAccount(accountRequest)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        creditCard = {
                            cardHolderName: cardHolderName,
                            cardNumber: cardNumber,
                            expiryMonth: ccExpirationDate.split('/')[0],
                            expiryYear: ccExpirationDate.split('/')[1],
                        };
                        _a.label = 3;
                    case 3:
                        _a.trys.push([3, 6, , 7]);
                        return [4, this.rootStore.api.V1.Lookup.Payment.AvailablePaymentMethods()];
                    case 4:
                        gateWays = _a.sent();
                        return [4, this.rootStore.ccTokenizerClient.TokenizeCreditCard(gateWays.availablePaymentMethods[0].gatewayType.toLowerCase(), this.rootStore.config.wholesaleCustomerCode + "-" + this.accountCode, creditCard, isOssUser)];
                    case 5:
                        _a.sent();
                        return [3, 7];
                    case 6:
                        error_2 = _a.sent();
                        this.failedSale(error_2);
                        return [2];
                    case 7: return [4, this.createSale()];
                    case 8:
                        _a.sent();
                        return [2];
                }
            });
        });
    };
    SaleStore.prototype.createAccount = function (accountRequest) {
        return __awaiter(this, void 0, void 0, function () {
            var response, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4, this.rootStore.api.V1.Account.Create(accountRequest)];
                    case 1:
                        response = _a.sent();
                        this.accountCode = response.accountCode;
                        return [3, 3];
                    case 2:
                        error_3 = _a.sent();
                        this.failedSale(error_3);
                        return [3, 3];
                    case 3: return [2];
                }
            });
        });
    };
    SaleStore.prototype.createSale = function () {
        return __awaiter(this, void 0, void 0, function () {
            var wholesaleCustomerCode, messageType, accountCode, _a, accountNumber, address, contractCode, fullName, numberToPort, voipCode, voipCsgWaiverAccepted, includeVoipBundle, existingNumber, _b, nbnOrderType, nbnBoxAtPremises, medicalSecurityAlarm, provisioningCommencementDate, startOrdering, nbnEslaService, _c, nbnLocId, serviceClass, isLineInUse, newDevelopmentsChargeApplies, newConnectionChargeApplies, newConnectionCharge, newDevelopmentsCharge, providerCode, flipToFibreService, firstName, hardwareCode, contacts, voipNumberRequest, newVoipSaleRequest, newNbnOrderType, planDetails, nbnEslaDetails, isFlipToFibre, noteLogInformation, newSaleRequest, response, _d, error_4;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        wholesaleCustomerCode = this.rootStore.config.wholesaleCustomerCode;
                        messageType = wholesaleCustomerCode === 'OT' ? 'SMS' : 'Email';
                        accountCode = this.accountCode;
                        _a = this.rootStore.planStore.planDetails.formValues, accountNumber = _a.accountNumber, address = _a.address, contractCode = _a.contractCode, fullName = _a.fullName, numberToPort = _a.numberToPort, voipCode = _a.voipCode, voipCsgWaiverAccepted = _a.voipCsgWaiverAccepted, includeVoipBundle = _a.includeVoipBundle, existingNumber = _a.existingNumber;
                        _b = this.rootStore.connectionDetailsStore.connectionDetails.formValues, nbnOrderType = _b.nbnOrderType, nbnBoxAtPremises = _b.nbnBoxAtPremises, medicalSecurityAlarm = _b.medicalSecurityAlarm, provisioningCommencementDate = _b.provisioningCommencementDate, startOrdering = _b.startOrdering, nbnEslaService = _b.nbnEslaService;
                        _c = this.rootStore.checkAddressStore, nbnLocId = _c.nbnLocId, serviceClass = _c.serviceClass, isLineInUse = _c.isLineInUse, newDevelopmentsChargeApplies = _c.newDevelopmentsChargeApplies, newConnectionChargeApplies = _c.newConnectionChargeApplies, newConnectionCharge = _c.newConnectionCharge, newDevelopmentsCharge = _c.newDevelopmentsCharge, providerCode = _c.providerCode, flipToFibreService = _c.flipToFibreService;
                        firstName = this.rootStore.detailsStore.details.formValues.firstName;
                        hardwareCode = this.rootStore.hardwareStore.hardwareDetails.formValues.hardwareCode;
                        this.firstName = firstName;
                        this.loading = true;
                        contacts = this.mapContacts();
                        voipNumberRequest = {
                            accountNumber: accountNumber,
                            address: address,
                            fullName: fullName,
                            numberToPort: numberToPort,
                        };
                        newVoipSaleRequest = __assign(__assign({ accountCode: accountCode,
                            contacts: contacts,
                            contractCode: contractCode, hardwareCodes: [hardwareCode], isOnlinePurchase: this.voucherCode ? false : true, preferredMessageType: messageType, voipCsgWaiverAccepted: voipCsgWaiverAccepted, voipNumberPort: voipNumberRequest }, (this.voucher && {
                            voucherAmount: this.voucher.amount,
                            voucherId: this.voucher.id,
                        })), (this.promo &&
                            this.promo.success && {
                            promoCode: this.promoCode,
                            promoAmount: this.promo.amount,
                        }));
                        newNbnOrderType = this.setNbnOrderType();
                        planDetails = "Plan Details:\n Service Plan Code: " + contractCode + "\n";
                        if (voipCode) {
                            planDetails += "VoIP Bundle: " + voipCode + "\n Use Existing Number: " + (existingNumber ? 'Yes' : 'No') + "\n";
                            if (existingNumber) {
                                planDetails += "Number to Port: " + numberToPort + "\nFull Name: " + fullName + "\nAddress: " + address + "\nAccount Number: " + accountNumber + "\nWaiver Accepted: " + (voipCsgWaiverAccepted ? 'Yes' : 'No');
                            }
                        }
                        nbnEslaDetails = '';
                        if (providerCode === 'OPTUS') {
                            nbnEslaDetails = "<strong>nbn Esla Service: " + (nbnEslaService ? 'Yes' : 'No') + "</strong>\n";
                        }
                        isFlipToFibre = '';
                        if (flipToFibreService) {
                            isFlipToFibre = 'Flip to Fibre Service: Yes\n';
                        }
                        noteLogInformation = "Service Class: " + serviceClass + "\n Location ID: " + nbnLocId + "\n " + isFlipToFibre + " " + planDetails + "\n Hardware Code: " + Object.values(this.rootStore.hardwareStore.hardwareDetails.formValues)
                            .filter(function (val) { return val; })
                            .toString() + "\n\n Connection Details:\n Line in Use: " + (isLineInUse ? 'Yes' : 'No') + "\n Service Transfer: " + (nbnOrderType === 'ServiceTransfer' ? 'Yes' : 'No') + "\n " + (nbnBoxAtPremises
                            ? "Box at Premise: " + (nbnBoxAtPremises === 'NotSure' ? 'Not Sure' : nbnBoxAtPremises) + "\n "
                            : '') + "Order Type: " + newNbnOrderType + "\n Start Ordering: " + (startOrdering ? 'Yes' : 'No') + "\n Provisioning Commencement Date: " + provisioningCommencementDate + "\n Medical Security Alarm: " + (medicalSecurityAlarm ? 'Yes' : 'No') + "\n Priority Assistance: No\n " + nbnEslaDetails;
                        newSaleRequest = __assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign({ accountCode: accountCode,
                            contacts: contacts,
                            contractCode: contractCode, nbnOrderType: newNbnOrderType, provisioningCommencementDate: provisioningCommencementDate }, {
                            hardwareCodes: Object.values(this.rootStore.hardwareStore.hardwareDetails.formValues).filter(function (val) { return val; }),
                        }), { isOnlinePurchase: this.voucherCode ? false : true, preferredMessageType: messageType, voipCode: voipCode,
                            voipCsgWaiverAccepted: voipCsgWaiverAccepted, voipNumberPort: voipNumberRequest }), (this.voucher && {
                            voucherAmount: this.voucher.amount,
                            voucherId: this.voucher.id,
                        })), (this.promo &&
                            this.promo.success && {
                            promoCode: this.promoCode,
                            promoAmount: this.promo.amount,
                        })), { noteLogInformation: noteLogInformation, newDevelopmentsChargeApplies: newDevelopmentsChargeApplies }), (newDevelopmentsChargeApplies && {
                            newDevelopmentsCharge: newDevelopmentsCharge,
                        })), { newConnectionChargeApplies: newConnectionChargeApplies }), (newConnectionChargeApplies && {
                            newConnectionCharge: newConnectionCharge,
                        })), { nbnEslaServiceAdded: nbnEslaService, flipToFibreService: flipToFibreService, serviceClass: this.rootStore.checkAddressStore.serviceClass, nbnLocId: this.rootStore.checkAddressStore.nbnLocId });
                        _e.label = 1;
                    case 1:
                        _e.trys.push([1, 6, , 7]);
                        if (!(wholesaleCustomerCode === 'BDF')) return [3, 3];
                        return [4, this.rootStore.api.V1.Sale.Voip.Index(newVoipSaleRequest)];
                    case 2:
                        _d = _e.sent();
                        return [3, 5];
                    case 3: return [4, this.rootStore.api.V1.Sale.Broadband.Index(newSaleRequest)];
                    case 4:
                        _d = _e.sent();
                        _e.label = 5;
                    case 5:
                        response = _d;
                        if (response.paymentResultCode === '09') {
                            this.paymentReference =
                                'No payment required as account is in credit or balance is $0.00';
                        }
                        else {
                            this.paymentReference = response.paymentReference;
                        }
                        this.serviceCode = response.serviceCode;
                        this.loading = false;
                        this.accountCode = null;
                        return [3, 7];
                    case 6:
                        error_4 = _e.sent();
                        this.failedSale(error_4);
                        return [2];
                    case 7:
                        this.rootStore.appStore.nextStep();
                        return [2];
                }
            });
        });
    };
    SaleStore.prototype.mapAccountCreationRequest = function () {
        var wholesaleCustomerCode = this.rootStore.config.wholesaleCustomerCode;
        var messageType = wholesaleCustomerCode === 'OT' ? 'SMS' : 'Email';
        var _a = this.rootStore.detailsStore.details.formValues, abn = _a.abn, businessName = _a.businessName, isBusiness = _a.isBusiness, externalId = _a.externalId;
        return {
            abn: abn,
            businessName: businessName,
            contacts: this.mapContacts(),
            isBusiness: isBusiness,
            externalId: externalId,
            preferredMessageType: messageType,
        };
    };
    SaleStore.prototype.mapContacts = function () {
        var contacts = [];
        var _a = this.rootStore.detailsStore.details.formValues, billingAddressLevelNumber = _a.billingAddressLevelNumber, billingAddressLevelType = _a.billingAddressLevelType, billingAddressPostcode = _a.billingAddressPostcode, billingAddressRequired = _a.billingAddressRequired, billingAddressState = _a.billingAddressState, billingAddressStreetName = _a.billingAddressStreetName, billingAddressStreetNumber = _a.billingAddressStreetNumber, billingAddressStreetType = _a.billingAddressStreetType, billingAddressSuburb = _a.billingAddressSuburb, billingAddressUnitNumber = _a.billingAddressUnitNumber, billingAddressUnitType = _a.billingAddressUnitType, dateOfBirth = _a.dateOfBirth, deliveryAddressLevelNumber = _a.deliveryAddressLevelNumber, deliveryAddressLevelType = _a.deliveryAddressLevelType, deliveryAddressPostcode = _a.deliveryAddressPostcode, deliveryAddressRequired = _a.deliveryAddressRequired, deliveryAddressState = _a.deliveryAddressState, deliveryAddressStreetName = _a.deliveryAddressStreetName, deliveryAddressStreetNumber = _a.deliveryAddressStreetNumber, deliveryAddressStreetType = _a.deliveryAddressStreetType, deliveryAddressSuburb = _a.deliveryAddressSuburb, deliveryAddressUnitNumber = _a.deliveryAddressUnitNumber, deliveryAddressUnitType = _a.deliveryAddressUnitType, emailAddress = _a.emailAddress, firstName = _a.firstName, lastName = _a.lastName, phoneNumber = _a.phoneNumber, phoneType = _a.phoneType, title = _a.title;
        var ownerContact = __assign(__assign(__assign({ address: this.rootStore.checkAddressStore.manualAddress, contactTypes: ['Owner'], dateOfBirth: DateTime.fromFormat(dateOfBirth, 'dd/MM/yyyy').toFormat('yyyy-MM-dd'), emailAddress: emailAddress,
            firstName: firstName,
            lastName: lastName,
            title: title }, (phoneType === 'home' && { phoneHome: phoneNumber })), (phoneType === 'mobile' && { phoneMobile: phoneNumber })), (phoneType === 'work' && { phoneWork: phoneNumber }));
        contacts.push(ownerContact);
        if (billingAddressRequired) {
            var billingAddress = __assign(__assign(__assign(__assign(__assign({}, (billingAddressLevelType && {
                levelType: billingAddressLevelType,
            })), (billingAddressLevelNumber && {
                levelNumber: billingAddressLevelNumber,
            })), { postCode: billingAddressPostcode, state: billingAddressState, streetName: billingAddressStreetName, streetNumber: billingAddressStreetNumber, streetType: billingAddressStreetType, suburb: billingAddressSuburb }), (billingAddressUnitNumber && {
                unitNumber: billingAddressUnitNumber,
            })), (billingAddressUnitType && {
                unitType: billingAddressUnitType,
            }));
            contacts.push(__assign(__assign(__assign({ address: billingAddress, contactTypes: ['Billing'], dateOfBirth: DateTime.fromFormat(dateOfBirth, 'dd/MM/yyyy').toFormat('yyyy-MM-dd'), emailAddress: emailAddress,
                firstName: firstName,
                lastName: lastName,
                title: title }, (phoneType === 'home' && { phoneHome: phoneNumber })), (phoneType === 'mobile' && { phoneMobile: phoneNumber })), (phoneType === 'work' && { phoneWork: phoneNumber })));
        }
        else {
            ownerContact.contactTypes.push('Billing');
        }
        if (deliveryAddressRequired) {
            var deliveryAddress = __assign(__assign(__assign(__assign(__assign({}, (deliveryAddressLevelType && {
                levelType: deliveryAddressLevelType,
            })), (deliveryAddressLevelNumber && {
                levelNumber: deliveryAddressLevelNumber,
            })), { postCode: deliveryAddressPostcode, state: deliveryAddressState, streetName: deliveryAddressStreetName, streetNumber: deliveryAddressStreetNumber, streetType: deliveryAddressStreetType, suburb: deliveryAddressSuburb }), (deliveryAddressUnitNumber && {
                unitNumber: deliveryAddressUnitNumber,
            })), (deliveryAddressUnitType && {
                unitType: deliveryAddressUnitType,
            }));
            contacts.push(__assign(__assign(__assign({ address: deliveryAddress, contactTypes: ['Shipping'], dateOfBirth: DateTime.fromFormat(dateOfBirth, 'dd/MM/yyyy').toFormat('yyyy-MM-dd'), emailAddress: emailAddress,
                firstName: firstName,
                lastName: lastName,
                title: title }, (phoneType === 'home' && { phoneHome: phoneNumber })), (phoneType === 'mobile' && { phoneMobile: phoneNumber })), (phoneType === 'work' && { phoneWork: phoneNumber })));
        }
        else {
            ownerContact.contactTypes.push('Shipping');
        }
        return contacts;
    };
    SaleStore.prototype.setNbnOrderType = function () {
        var _a = this.rootStore.connectionDetailsStore.connectionDetails.formValues, nbnOrderType = _a.nbnOrderType, nbnBoxAtPremises = _a.nbnBoxAtPremises, nbnEslaService = _a.nbnEslaService;
        var _b = this.rootStore.checkAddressStore, serviceClass = _b.serviceClass, isLineInUse = _b.isLineInUse, flipToFibreService = _b.flipToFibreService;
        var provider = this.rootStore.checkAddressStore.providerCode;
        var includeVoipBundle = this.rootStore.planStore.planDetails.formValues.includeVoipBundle;
        if (provider === 'Uniti') {
            if (isLineInUse) {
                if (nbnOrderType === 'ServiceTransfer') {
                    return 'UnitiTransferOrder';
                }
                if (nbnOrderType === 'NewServiceOrder') {
                    return 'UnitiNewOrder';
                }
            }
            return 'UnitiNewOrder';
        }
        if (flipToFibreService) {
            return 'NewManualOrder';
        }
        if (includeVoipBundle || nbnEslaService) {
            return 'NewManualOrder';
        }
        if ([3, 13, 24, 34].includes(serviceClass)) {
            if (isLineInUse) {
                if (nbnOrderType === 'ServiceTransfer') {
                    return 'ServiceTransferRemoteActivation';
                }
                if (nbnOrderType === 'NewServiceOrder') {
                    if ([24, 34].includes(serviceClass)) {
                        return nbnBoxAtPremises === 'Yes'
                            ? 'ServiceTransferRemoteActivation'
                            : 'ServiceTransferNtdRequired';
                    }
                    if (![24, 34].includes(serviceClass)) {
                        return 'ServiceTransferRemoteActivation';
                    }
                }
            }
            if (!isLineInUse) {
                if ([24, 34].includes(serviceClass)) {
                    return nbnBoxAtPremises === 'Yes'
                        ? 'NewOrderRemoteActivation'
                        : 'NewConnectionNtdRequired';
                }
                if (![24, 34].includes(serviceClass)) {
                    return 'NewOrderRemoteActivation';
                }
            }
        }
        return 'NewOrderAppointment';
    };
    __decorate([
        observable,
        __metadata("design:type", String)
    ], SaleStore.prototype, "accountCode", void 0);
    __decorate([
        observable,
        __metadata("design:type", String)
    ], SaleStore.prototype, "serviceCode", void 0);
    __decorate([
        observable,
        __metadata("design:type", String)
    ], SaleStore.prototype, "firstName", void 0);
    __decorate([
        observable,
        __metadata("design:type", String)
    ], SaleStore.prototype, "paymentReference", void 0);
    __decorate([
        observable,
        __metadata("design:type", Boolean)
    ], SaleStore.prototype, "loading", void 0);
    __decorate([
        observable,
        __metadata("design:type", Boolean)
    ], SaleStore.prototype, "ow30DayAccountValid", void 0);
    __decorate([
        observable,
        __metadata("design:type", Object)
    ], SaleStore.prototype, "paymentDetails", void 0);
    __decorate([
        observable,
        __metadata("design:type", String)
    ], SaleStore.prototype, "paymentMethod", void 0);
    __decorate([
        observable,
        __metadata("design:type", String)
    ], SaleStore.prototype, "voucherCode", void 0);
    __decorate([
        observable,
        __metadata("design:type", Object)
    ], SaleStore.prototype, "voucher", void 0);
    __decorate([
        observable,
        __metadata("design:type", String)
    ], SaleStore.prototype, "promoCode", void 0);
    __decorate([
        observable,
        __metadata("design:type", Object)
    ], SaleStore.prototype, "promo", void 0);
    __decorate([
        observable,
        __metadata("design:type", String)
    ], SaleStore.prototype, "recaptchaResponse", void 0);
    __decorate([
        action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], SaleStore.prototype, "setRecaptchaResponse", null);
    __decorate([
        action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], SaleStore.prototype, "setVoucherCode", null);
    __decorate([
        action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], SaleStore.prototype, "setVoucher", null);
    __decorate([
        action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], SaleStore.prototype, "setPromoCode", null);
    __decorate([
        action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], SaleStore.prototype, "setPromo", null);
    __decorate([
        action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], SaleStore.prototype, "setDetailsFromForm", null);
    __decorate([
        action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", void 0)
    ], SaleStore.prototype, "isLoading", null);
    __decorate([
        action,
        __metadata("design:type", Object)
    ], SaleStore.prototype, "reset", void 0);
    __decorate([
        action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], SaleStore.prototype, "setPaymentMethod", null);
    __decorate([
        action,
        __metadata("design:type", Object)
    ], SaleStore.prototype, "failedSale", void 0);
    __decorate([
        action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", Promise)
    ], SaleStore.prototype, "tokenizeOfficeWorksLogin", null);
    __decorate([
        action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", Promise)
    ], SaleStore.prototype, "submitCreditCardForm", null);
    __decorate([
        action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", Promise)
    ], SaleStore.prototype, "createAccount", null);
    __decorate([
        action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], SaleStore.prototype, "createSale", null);
    __decorate([
        action,
        __metadata("design:type", Object)
    ], SaleStore.prototype, "getInitialStoreState", void 0);
    return SaleStore;
}());
export { SaleStore };
//# sourceMappingURL=SaleStore.js.map